import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlmResourceUploaderComponent } from './glm-resource-uploader/glm-resource-uploader.component';
import { GlmResourceViewerComponent } from './glm-resource-viewer/glm-resource-viewer.component';
import { MatButtonModule } from '@angular/material/button';
import { GlmResourceItemViewComponent } from './glm-resource-item-view/glm-resource-item-view.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';



@NgModule({
  declarations: [GlmResourceUploaderComponent, GlmResourceViewerComponent, GlmResourceItemViewComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    PdfJsViewerModule,
  ],
  exports: [GlmResourceUploaderComponent, GlmResourceViewerComponent, GlmResourceItemViewComponent]
})
export class GlmResourceUploadModule { }
